/** Publiczny moduł sklepu dla odwiedzających. CMS i API pozostają bez zmian. */
export const SHOP_PUBLIC_ENABLED = false;
